export interface PackageSize {
  value: string;
  label: string;
  weight: string;
  grams: number;
}

export const PACKAGE_SIZES: PackageSize[] = [
  { value: 'XS', label: 'Extra Pequeño (XS)', weight: 'Max 1Kg', grams: 1000 },
  { value: 'S', label: 'Pequeño (S)', weight: 'Max 2Kg', grams: 2000 },
  { value: 'M', label: 'Mediano (M)', weight: 'Max 6Kg', grams: 6000 },
  { value: 'L', label: 'Grande (L)', weight: 'Max 15Kg', grams: 15000 },
  { value: 'XL', label: 'Extra Grande (XL)', weight: 'Max 25Kg', grams: 25000 },
];

export interface PickupCountry {
  value: string;
  label: string;
  code: string;
  requiresZipcode: boolean;
}

export const PICKUP_COUNTRIES: PickupCountry[] = [
  { value: 'MEX', label: 'México', code: 'MX', requiresZipcode: true },
  { value: 'COL', label: 'Colombia', code: 'CO', requiresZipcode: true },
  { value: 'CHL', label: 'Chile', code: 'CL', requiresZipcode: false },
  { value: 'PER', label: 'Perú', code: 'PE', requiresZipcode: false },
];

/**
 * Generates the selection options for package sizes
 * @returns Array of options with format "Label - Weight"
 */
export const getPackageSizeOptions = () => {
  return PACKAGE_SIZES.map((size) => ({
    value: size.value,
    label: `${size.label} - ${size.weight}`,
  }));
};

/**
 * Maps Google country code to the system's country code
 */
export const mapGoogleToPickupCountry = (googleCountryCode: string): string => {
  const countryMap: Record<string, string> = {
    MX: 'MEX',
    CO: 'COL',
    CL: 'CHL',
    PE: 'PER',
  };
  return countryMap[googleCountryCode] || '';
};

/**
 * Checks if a country requires a mandatory postal code
 */
export const pickupCountryRequiresZipcode = (countryCode: string): boolean => {
  const country = PICKUP_COUNTRIES.find((c) => c.value === countryCode);
  return country?.requiresZipcode ?? false;
};
